import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VForm } from 'vuetify/lib/components/VForm';

var render = function render() {
  var _vm$userListPreLoaded, _vm$consultantListPre;
  var _vm = this,
    _c = _vm._self._c;
  return _c(VForm, {
    staticClass: "dfwa-form",
    model: {
      value: _vm.valid,
      callback: function callback($$v) {
        _vm.valid = $$v;
      },
      expression: "valid"
    }
  }, [_c(VAutocomplete, {
    staticClass: "required",
    attrs: {
      items: _vm.availableStockReservationTypes,
      label: _vm.isPrefixedWithDefault ? "Default stock reservation type" : "Reservation type",
      "item-value": "id",
      "item-text": "name",
      rules: [_vm.formRules.mustSelectValueZeroOk],
      readonly: _vm.readonly,
      filter: _vm.filterVAutocomplete,
      "hide-details": "auto"
    },
    on: {
      change: function change(value) {
        if (value !== _vm.stockReservationTypes.SPECIFIC_CUSTOMER.id) {
          _vm.form.stockReservationUserId = null;
        }
        if (value !== _vm.stockReservationTypes.SPECIFIC_CONSULTANT.id) {
          _vm.form.stockReservationConsultantId = null;
        }
        _vm.updateData();
      }
    },
    model: {
      value: _vm.form.stockReservationType,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "stockReservationType", $$v);
      },
      expression: "form.stockReservationType"
    }
  }), +_vm.form.stockReservationType === +_vm.stockReservationTypes.SPECIFIC_CUSTOMER.id ? _c("div", [_c(VAutocomplete, {
    staticClass: "required",
    attrs: {
      items: (_vm$userListPreLoaded = _vm.userListPreLoaded) !== null && _vm$userListPreLoaded !== void 0 ? _vm$userListPreLoaded : _vm.gettingUserList.results,
      label: _vm.gettingUserList.isPending ? "Loading users list..." : _vm.isPrefixedWithDefault ? "Default stock reservation for" : "Reserved for",
      disabled: _vm.gettingUserList.isPending,
      placeholder: "Search for a user",
      "no-data-text": _vm.gettingUserList.isPending ? "Loading..." : "No match",
      "item-value": "id_user",
      "item-text": "full_name",
      rules: [_vm.formRules.mustSelectValue],
      readonly: _vm.readonly,
      filter: _vm.filterVAutocomplete,
      "hide-details": "auto"
    },
    on: {
      change: function change($event) {
        return _vm.updateData();
      }
    },
    model: {
      value: _vm.form.stockReservationUserId,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "stockReservationUserId", $$v);
      },
      expression: "form.stockReservationUserId"
    }
  }), _vm.reservedForMessage && _vm.reservedForMessage.length > 0 ? _c("div", {
    staticClass: "text-italic text-left mt-1"
  }, [_vm._v(" " + _vm._s(_vm.reservedForMessage) + " ")]) : _vm._e()], 1) : +_vm.form.stockReservationType === +_vm.stockReservationTypes.SPECIFIC_CONSULTANT.id ? _c("div", [_c(VAutocomplete, {
    staticClass: "required",
    attrs: {
      items: (_vm$consultantListPre = _vm.consultantListPreLoaded) !== null && _vm$consultantListPre !== void 0 ? _vm$consultantListPre : _vm.gettingConsultantList.results,
      label: _vm.gettingConsultantList.isPending ? "Loading corporates list..." : _vm.isPrefixedWithDefault ? "Default stock reservation for" : "Reserved for",
      disabled: _vm.gettingConsultantList.isPending,
      placeholder: "Search for a Corporate",
      "no-data-text": _vm.gettingConsultantList.isPending ? "Loading..." : "No match",
      "item-value": "id",
      "item-text": "full_name",
      rules: [_vm.formRules.mustSelectValue],
      readonly: _vm.readonly,
      filter: _vm.filterVAutocomplete,
      "hide-details": "auto"
    },
    on: {
      change: function change($event) {
        return _vm.updateData();
      }
    },
    model: {
      value: _vm.form.stockReservationConsultantId,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "stockReservationConsultantId", $$v);
      },
      expression: "form.stockReservationConsultantId"
    }
  }), _vm.reservedForMessage && _vm.reservedForMessage.length > 0 ? _c("div", {
    staticClass: "text-italic text-left mt-1"
  }, [_vm._v(" " + _vm._s(_vm.reservedForMessage) + " ")]) : _vm._e()], 1) : _vm._e(), _c("ErrorModal", {
    ref: _vm.ERROR_DATA.ref
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };